import React from 'react';

import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {apiIdToIconName} from 'util/APIUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {ChipItem, SmartChipType} from './useSmartChipQuery';

function getSecondaryText(worksheet: ChipItem<SmartChipType.WORKSHEET>): string | null {
  return worksheet.displayId;
}

export default function WorksheetChip(props: SharedSmartChipProps<SmartChipType.WORKSHEET>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick, hideSecondaryText} = sharedSmartChipProps;

  const {
    item: worksheet,
    handleClickLink,
    isInaccessible,
    itemUrl: worksheetUrl,
  } = useSmartChipQuery<SmartChipType.WORKSHEET>({
    id,
    onClick,
    getUrlFn: ({editUrl}) => editUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={worksheet != null ? apiIdToIconName(worksheet.id) : null}
      isInaccessible={isInaccessible}
      item={worksheet}
      onClick={handleClickLink}
      url={worksheetUrl}
      getSecondaryText={hideSecondaryText ? undefined : getSecondaryText}
    />
  );
}
